import "./LeftColorBlockBox.scss";
import PropTypes from 'prop-types';
import { IconJsxer } from "../../helpers/IconHelper";
import { LEFT_COLOR_BLOCK_STYLES } from "./LeftColorBlockBox";
import LottieIcon from "../common/LottieIcon";

const LeftColorBlockHeadedPanel = (props) => {
    const {style, fullWidth, headingContent, children, overrideColor, overrideBgColor, className, onClickHandler, boxClassName} = props;
    let styleData = style;

    if (typeof styleData === 'string') {
        if (styleData === 'feature') styleData = 'feature_default';
        if (styleData === 'disruptor') styleData = 'disruptor_default';
        styleData = LEFT_COLOR_BLOCK_STYLES[styleData];
    }
    if (typeof styleData === 'undefined') {
        styleData = LEFT_COLOR_BLOCK_STYLES.default;
    }

    let overrideStyleData = overrideColor;
    if (overrideColor) {
        if (typeof overrideStyleData === 'string') {
            if (overrideStyleData === 'feature') overrideStyleData = 'feature_default';
            if (overrideStyleData === 'disruptor') overrideStyleData = 'disruptor_default';
            overrideStyleData = LEFT_COLOR_BLOCK_STYLES[overrideStyleData];
        }
        if (typeof overrideStyleData === 'undefined') {
            overrideStyleData = LEFT_COLOR_BLOCK_STYLES.default;
        }
    }

    const extraStyle = {};
    if (overrideBgColor) {
        extraStyle.backgroundColor = overrideBgColor;
    }
    if (styleData?.customColor) {
        extraStyle.borderColor = styleData.customColor;
    }
    if (props.customColor && !props.neutralBorder) {
        extraStyle.borderColor = props.customColor;
    }

    const leftBlockStyle = {
        ...(styleData?.customColor && !props.iconBoxOnly ? { backgroundColor: styleData.customColor } : {}),
        ...(props.customColor && !props.iconBoxOnly ? { backgroundColor: props.customColor } : {}),
    };

    return (
        <div className={`lcb-headed-panel-holder ${fullWidth ? 'lcb-full-width' : ''}${className ? ` ${className}` : ' grow'}`}>
            <div
                className={`left-color-block-box grow lcb-heading${props.compact ? ' lcb-compact' : ''}${boxClassName ? ` ${boxClassName}` : ''}${onClickHandler ? ' clickable' : ''}`}
                {...(onClickHandler ? { onClick: onClickHandler, role: 'button', tabIndex: 0, onKeyDown: (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onClickHandler(e);
                    }
                }} : {})}
            >
                <div className={`content-block left ${'lcb-' + (overrideStyleData ? overrideStyleData.color : styleData.color) + '-left'}${props.whiteIcon ? ' white-icon' : ''} lcb-heading`} style={leftBlockStyle}>
                    {!props.customIconVarKey && IconJsxer.GetIcon(styleData.icon, IconJsxer.ICON_STYLES.analyticsColourBlockIcon)}
                    {props.customIconVarKey && (
                        <span className={`lcb-custom-icon-lozenge${props.iconBoxOnly ? ' icon-box-only' : ''}`} style={props.iconBoxOnly && props.customColor ? { backgroundColor: props.customColor } : undefined}>
                            <LottieIcon icon={props.customIcon} varKey={props.customIconVarKey} size={24} />
                        </span>
                    )}
                </div>
                <div className={`content-block right ${'lcb-' + (overrideStyleData ? overrideStyleData.color : styleData.color) + '-right'} lcb-heading`} style={extraStyle}>
                    {headingContent}
                </div>
            </div>
            <div className="lcb-headed-content" style={extraStyle}>
                {children}
            </div>
        </div>
    )
}

LeftColorBlockHeadedPanel.propTypes = {
    style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    className: PropTypes.string,
    overrideColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    overrideBgColor: PropTypes.string,
    fullWidth: PropTypes.bool,
    headingContent: PropTypes.element,
    compact: PropTypes.bool,
    customColor: PropTypes.string,
    customIcon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    customIconVarKey: PropTypes.string,
    neutralBorder: PropTypes.bool,
    iconBoxOnly: PropTypes.bool,
    whiteIcon: PropTypes.bool,
    boxClassName: PropTypes.string,
};

LeftColorBlockHeadedPanel.defaultProps = {
    style: 'default',
    fullWidth: true,
}

export default LeftColorBlockHeadedPanel;
